import BaseRailsRequestController from "./base_rails_request_controller";
import TomSelect from "tom-select";

// Connects to data-controller="adr-modal"
export default class extends BaseRailsRequestController {
  static classes = ["loadingOptions"];
  static targets = ["unNumberSelect", "classificationSelect", "classificationSelectWrapper"];
  static values = {
    url: String,
    noResultsMessage: String,
  };

  connect() {
    const thisInstance = this;

    new TomSelect(this.unNumberSelectTarget, {
      valueField: "id",
      maxItems: 1,
      closeAfterSelect: true,
      labelField: "text",
      sortField: {
        field: "text",
        direction: "asc",
      },
      controlInput: null,
      plugins: ["dropdown_input"],
      searchField: ["un_number", "name_nl", "name_en"],
      onDelete: function () {
        return false;
      },
      onChange: function (value) {
        if (value === "") return; // Avoid empty selection
        const selectedOption = this.getItem(value);
        const url = selectedOption.dataset.url;

        thisInstance.getDangerousGoodDetails(url);
        thisInstance.getClassificationOptions(url);
      },
      onInitialize: function () {
        thisInstance.element.classList.add(thisInstance.loadingOptionsClass);
        var self = this;
        thisInstance
          .fetchWithProgress("get", thisInstance.urlValue)
          .then((response) => response.json)
          .then((json) => {
            self.addOptions(json);

            const value = thisInstance.unNumberSelectTarget.dataset.selectedDangerousGood;

            if (value) {
              self.setValue(value);
            }
          })
          .finally(() => {
            thisInstance.element.classList.remove(thisInstance.loadingOptionsClass);
          });
      },
      render: {
        item: function (data, escape) {
          return `<div class="text-truncate" data-url="${escape(data.url)}">${escape(data.text)}</div>`;
        },
        no_results: () => {
          return `<div class="no-results">${this.noResultsMessageValue}</div>`;
        },
      },
    });
    this.classificationTomSelect = new TomSelect(this.classificationSelectTarget, {
      valueField: "id",
      controlInput: null,
      onChange: function (value) {
        const selectedOption = this.getItem(value);
        const url = selectedOption.dataset.url;

        thisInstance.getDangerousGoodDetails(url);
      },
      render: {
        item: function (data, escape) {
          return `<div class="text-truncate" data-url="${escape(data.url)}" >${escape(data.packing_group)} ${escape(data.classification_code)}</div>`;
        },
        no_results: () => {
          return `<div class="no-results">${this.noResultsMessageValue}</div>`;
        },
      },
    });
  }

  getClassificationOptions(url) {
    this.element.classList.add(this.loadingOptionsClass);

    const thisInstance = this;
    this.fetchWithProgress("get", url, {
      responseKind: "json",
    })
      .then((response) => response.json)
      .then((json) => {
        this.classificationTomSelect.clear(true);
        this.classificationTomSelect.clearOptions();
        if (json.options.length <= 1) {
          this.classificationTomSelect.disable();
        } else {
          this.classificationTomSelect.enable();
        }

        this.classificationTomSelect.addOptions(json.options);

        const value = this.classificationSelectTarget.dataset.selectedClassification;

        if (value) {
          this.classificationTomSelect.setValue(value);
          return;
        }

        if (json.options.length > 0) {
          this.classificationTomSelect.setValue(json.options[0].id, true);
        }
      })
      .finally(() => {
        this.element.classList.remove(this.loadingOptionsClass);
      });
  }

  getDangerousGoodDetails(url) {
    this.fetchWithProgress("get", url, {
      responseKind: "turbo-stream",
    });
  }
}
